import { retailers } from '../api/retailers';

// this will serve as the source of truth for data that informs calculations
export const store = {
  state: {
    apiResults : [],
    retailers : [],
    location: {},
    loading: false,
    searched: false
  },
  // setters
  setLocation(location) {
    this.state.location = location;
  },
  async setRetailers(latitude, longitude, address, endpoints) {
    endpoints = endpoints || [];
    //handle a lack of input
    if (typeof latitude == 'undefined') {
      this.setLoading(false);
      console.warn('no latitude. cannot get agriculture retailers');
      return;
    }
    //give state info on current happening
    this.state.searched = true;
    this.setLoading(true);
    //send out to api
    if( endpoints.length > 0 ) {
      //reset results array to avoid duplicates
      this.state.apiResults = [];
      //get each endpoint (run in serial)
      for (const endpoint of endpoints) {
        //pull back values from each
        await retailers.getRetailers( endpoint, latitude, longitude, address )
          .then(res => { 
            //add valid results to our results list
            this.state.apiResults.push(res.data.dealershipResults)
          })
          .finally(() => {
            this.setLoading(false);
          });
      }
      //flatten a shallow copy of results (to get rid of observers within array)
      const flattenedResults = JSON.parse(JSON.stringify(this.state.apiResults)).flat();
      this.state.retailers = flattenedResults;

    } else {
      this.setLoading(false);
    }
  }, 
  setLoading(value) {
    this.state.loading = !!value; // convert to true/false
  },
  timedOut(){
    console.warn('timeout while loading');
    this.state.retailers = [];
    this.state.loading = false;
    this.state.searched = false;
  }
};
